import AboutUsImage from "../../../assets/images/HowWeWork.jpeg";
import {ReactComponent as Gather} from "../../../assets/icons/Gather.svg";
import {ReactComponent as Analyse} from "../../../assets/icons/AnalysePlaceholder.svg";
import {ReactComponent as Apply} from "../../../assets/icons/ApplyPlaceholder.svg";
import { ReactComponent as Review } from "../../../assets/icons/ReviewPlaceholder.svg";
import "../../../css/HowWeWork.css";

const HowWeWork = () => {
  return (
    <div className="about-section">
      <div className="about-section-content" >
        <div className="nav-bold secondary">About Us</div>
        <h2 className="primary">
          How <span style={{ fontStyle: "italic" }}>we Work</span>
        </h2>
        <div className="row">
          <div className="column align-left">
            <div className="nav-bold align-left primary" style={{fontWeight: "700"}}>
              Simple. Structured. Effective.
            </div>
            <div className="how-we-work-row">
              <div className="how-we-work-steps">
                <div className="how-we-work-step">
                  <div className="how-we-work-icon">
                    <Gather />
                  </div>
                  <div>
                    <div className="content-bold primary">Gather</div>
                    <div className="content primary">
                      We take the time to truly understand your life, goals, and
                      aspirations.
                    </div>
                  </div>
                </div>
                <div className="how-we-work-step">
                  <div className="how-we-work-icon">
                    <Analyse />
                  </div>
                  <div>
                    <div className="content-bold primary">Analyse</div>
                    <div className="content primary">
                      We assess your current position and identify opportunities
                      and risks.
                    </div>
                  </div>
                </div>
                <div className="how-we-work-step">
                  <div className="how-we-work-icon">
                    <Apply />
                  </div>
                  <div>
                    <div className="content-bold primary">Apply</div>
                    <div className="content primary">
                      We build and implement a tailored financial plan that
                      works for you.
                    </div>
                  </div>
                </div>
                <div className="how-we-work-step">
                  <div className="how-we-work-icon">
                    <Review />
                  </div>
                  <div>
                    <div className="content-bold primary">Review</div>
                    <div className="content primary">
                      We regularly refine your plan to keep it aligned with your
                      changing life.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="image-wrapper">
            <img src={AboutUsImage} alt="About Us" className="image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowWeWork;
